"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _BaseInput = _interopRequireDefault(require("../BaseInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledInput = (0, _styledComponents["default"])(_BaseInput["default"]).withConfig({
  displayName: "InputField__StyledInput",
  componentId: "sc-13vhyc-0"
})(function (_ref) {
  var theme = _ref.theme,
      error = _ref.error,
      type = _ref.type,
      width = _ref.width;
  return (0, _styledComponents.css)(["color:", ";font-size:1rem;font-weight:", ";border:none;border-bottom:0.1rem solid ", ";width:", ";padding:", " ", ";border-radius:", ";background-color:", ";background-image:", ";background-repeat:no-repeat;background-position:bottom;background-size:100% 20%;transition:0.2s background ease;text-align:", ";&::-webkit-calendar-picker-indicator{display:none;}&:focus{outline:none;background-color:", ";}"], theme.color.text, error ? theme.font.weight.bold : theme.font.weight.regular, error ? theme.color.warning : theme.color.action, width, theme.globalSizes.small, theme.globalSizes.xs, theme.globalSizes.smallest, theme.color.highlight, function (_ref2) {
    var error = _ref2.error,
        theme = _ref2.theme;
    return error ? theme.pattern.error : 'none';
  }, type === 'number' ? 'right' : 'left', theme.color.focus);
});
/**
 *
 * #### Input control component

This is a generic input field atom to be rendered into the text-based input variants.
 */

var InputField = /*#__PURE__*/React.forwardRef(function InputField(_ref3, ref) {
  var id = _ref3.id,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      _ref3$error = _ref3.error,
      error = _ref3$error === void 0 ? false : _ref3$error,
      _ref3$type = _ref3.type,
      type = _ref3$type === void 0 ? 'text' : _ref3$type,
      _ref3$maxLength = _ref3.maxLength,
      maxLength = _ref3$maxLength === void 0 ? '' : _ref3$maxLength,
      _ref3$onChange = _ref3.onChange,
      onChange = _ref3$onChange === void 0 ? function () {} : _ref3$onChange,
      _ref3$onBlur = _ref3.onBlur,
      onBlur = _ref3$onBlur === void 0 ? function () {} : _ref3$onBlur,
      _ref3$onKeyUp = _ref3.onKeyUp,
      onKeyUp = _ref3$onKeyUp === void 0 ? function () {} : _ref3$onKeyUp,
      _ref3$min = _ref3.min,
      min = _ref3$min === void 0 ? '' : _ref3$min,
      _ref3$max = _ref3.max,
      max = _ref3$max === void 0 ? '' : _ref3$max,
      _ref3$step = _ref3.step,
      step = _ref3$step === void 0 ? '' : _ref3$step,
      _ref3$list = _ref3.list,
      list = _ref3$list === void 0 ? '' : _ref3$list,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? '100%' : _ref3$width,
      _ref3$name = _ref3.name,
      name = _ref3$name === void 0 ? '' : _ref3$name,
      _ref3$value = _ref3.value,
      value = _ref3$value === void 0 ? '' : _ref3$value,
      rest = _objectWithoutProperties(_ref3, ["id", "className", "error", "type", "maxLength", "onChange", "onBlur", "onKeyUp", "min", "max", "step", "list", "width", "name", "value"]);

  return /*#__PURE__*/React.createElement(StyledInput, _extends({
    ref: ref,
    autoComplete: "off",
    className: className,
    id: id,
    type: type,
    maxLength: maxLength,
    onChange: onChange,
    onBlur: onBlur,
    onKeyUp: onKeyUp,
    min: min,
    max: max,
    width: width,
    step: step,
    list: list,
    error: error,
    "aria-invalid": error,
    name: name,
    value: value
  }, rest));
});
var _default = InputField;
exports["default"] = _default;